import { Typography, Box, Button, Stack, StarRateIcon } from "src/components";

export default function BookmarksPreview({ bookmarkIds, setHandbookMenuTab }) {
  const count = bookmarkIds?.length || 0;

  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        p: 2,
        borderRadius: 2,
        mb: 3,
        backgroundColor: '#ffffff',
      }}>
        {!count ?
            <Typography variant="body1" color="text.secondary">
                You haven’t bookmarked any articles yet. Start saving your favorite guides!
            </Typography>
            :
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <StarRateIcon color="primary" />
                    <Typography variant="body2" fontWeight={500}>
                        You’ve bookmarked {count} article{count > 1 ? 's' : ''}
                    </Typography>
                </Stack>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setHandbookMenuTab('bookmarks')}
                        sx={{ borderRadius: 5, whiteSpace: 'nowrap' }}
                        >
                        View All
                    </Button>
            </Stack>
        }
    </Box>
  );
}
